module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__officeBanking.fa019327.svg";